export default __webpack_public_path__ + "static/media/map_pin_bymelding_fra_publikum_ikke_behandlet.1c3756ec.svg";